var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g12, _g13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaby10Weeks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 133,
    viewBox: "0 0 229 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M114.361 132.001C177.521 132.001 228.722 126.291 228.722 119.248C228.722 112.205 177.521 106.495 114.361 106.495C51.2012 106.495 0 112.205 0 119.248C0 126.291 51.2012 132.001 114.361 132.001Z",
    fill: "#27AE60",
    fillOpacity: 0.79
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M215.59 107.903C215.429 107.927 215.269 107.956 215.108 107.993C215.324 107.943 215.697 108.068 215.915 108.105C216.195 108.153 216.474 108.209 216.75 108.274C217.251 108.392 217.745 108.417 218.156 108.77C218.508 109.072 218.697 109.615 218.459 110.013C218.225 110.403 217.71 110.499 217.259 110.543C216.431 110.625 215.599 110.668 214.766 110.673C215.623 110.94 218.636 111.851 217.391 113.132C216.636 113.908 214.11 113.758 213.114 113.766C213.495 113.763 213.961 114.166 214.249 114.376C214.628 114.653 215.053 114.948 215.173 115.432C215.257 115.771 215.18 116.161 214.925 116.399C214.741 116.571 214.485 116.65 214.233 116.664C213.441 116.708 212.696 116.403 211.937 116.224C210.076 115.785 208.219 115.33 206.366 114.86C203.941 114.244 202.682 113.587 200.2 114.489C191.961 117.484 182.626 118.003 174.23 115.329C166.225 112.78 159.246 109.129 154.489 101.88C151.668 97.579 147.406 89.1028 151.363 84.4523C153.213 82.277 156.082 81.2254 158.903 80.7845C163.949 79.9958 167.151 83.8235 170.696 86.6836C174.837 90.0235 178.589 93.8432 181.852 98.0448C182.348 98.6756 185.097 98.5257 185.84 98.6226C187.436 98.8295 189.019 99.1304 190.579 99.5233C193.7 100.308 196.728 101.46 199.58 102.953C201.263 103.834 202.102 103.172 203.871 102.874C205.519 102.597 207.202 102.537 208.866 102.686C211.14 102.889 213.38 103.481 215.451 104.443C216.19 104.786 217.941 105.404 218.275 106.223C218.771 107.44 217.362 107.739 216.426 107.817C216.145 107.837 215.867 107.862 215.59 107.903Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M149.212 80.9611C144.614 92.9631 151.835 102.681 151.835 102.681C151.835 102.681 162.506 104.441 176.095 89.5063C176.095 89.5063 161.527 65.8152 149.212 80.9611Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.5,
    d: "M149.212 80.9611C144.614 92.9631 151.835 102.681 151.835 102.681C151.835 102.681 162.506 104.441 176.095 89.5063C176.095 89.5063 161.527 65.8152 149.212 80.9611Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M176.252 88.1396C170.759 95.4252 160.628 101.967 151.006 101.997",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.5,
    d: "M179.814 99.2656C180.888 100.399 182.583 100.903 184.102 100.542",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.5,
    d: "M174.75 113.251C177.511 112.269 180.818 113.067 182.826 115.202",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M59.7579 64.4151C58.4423 64.3971 57.5136 74.6207 57.4567 75.7553C57.2527 79.773 57.5806 83.8076 58.1774 87.7803C58.7233 91.4131 59.2141 95.4337 60.8416 98.7486C62.534 102.194 65.619 104.058 68.571 106.339C71.9919 108.983 75.6636 111.32 79.6383 113.042C86.8369 116.161 95.2091 117.153 102.558 114.405C107.46 112.572 112.075 108.457 112.248 103.227C112.383 99.1925 109.861 95.5297 106.924 92.7586C100.5 86.6967 91.5124 83.4447 82.6973 83.9905C81.2658 77.5047 76.6093 69.6883 73.7972 63.6713C70.7363 57.1205 63.5547 50.0748 56.388 49.1161C53.667 48.7523 50.7659 48.9982 48.4167 50.4177C46.0675 51.8372 44.417 54.6043 44.8689 57.3124C45.3017 59.9096 47.526 61.9189 49.9881 62.8516C52.4503 63.7823 57.1258 64.3781 59.7579 64.4151Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M56.5411 70.5532C55.9013 69.0867 55.3994 67.0174 54.4437 65.7428C53.4121 64.3693 52.7173 64.8911 50.9439 64.8821C47.9499 64.8671 44.9569 64.1793 42.2648 62.8658C40.3514 61.9321 38.442 60.4696 38.0702 58.3733C37.8172 56.9458 38.3521 55.4612 39.2388 54.3146C40.1255 53.168 41.3361 52.3163 42.5807 51.5725C50.505 46.8341 62.0052 44.5869 68.776 52.2103C70.8003 54.4896 72.2348 57.1007 73.5894 59.6928C68.9989 63.7285 62.0612 67.5522 56.5411 70.5532Z",
    fill: "#FF766F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M73.4264 59.6592C67.9972 63.6329 62.2491 67.1717 56.2551 70.2287",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M142.269 66.6619C139.992 66.8088 138.949 68.3703 137.694 70.1267C136.711 71.5043 135.592 72.9988 133.639 74.0124C128.174 76.8485 120.945 76.0548 115.277 74.3573C107.401 71.9991 100.037 67.7445 91.8745 66.7599C78.0031 65.0854 63.6069 74.4633 59.5312 87.8278C55.4566 101.192 62.1713 117.007 74.6172 123.357C81.4499 126.843 89.3393 127.588 97.0098 127.66C115.617 127.834 135.513 127.147 151.504 116.355C157.748 112.142 163.074 106.386 166.483 99.6449C167.466 97.6996 168.777 94.5756 169.791 91.2067C156.353 89.8952 144.851 82.0698 142.269 66.6619Z",
    fill: "#2F80ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.5,
    d: "M131.901 122.127C110.679 124.78 88.1306 118.148 76.1926 99.5784C71.1923 92.3058 68.2193 84.4095 66.5748 76.1582C63.3669 79.4481 60.8787 83.4128 59.5332 87.8273C55.4585 101.192 62.1733 117.007 74.6192 123.357C81.4519 126.842 89.3412 127.587 97.0117 127.659C115.618 127.833 135.515 127.146 151.506 116.355C157.749 112.141 163.076 106.385 166.485 99.6444C167.468 97.699 168.779 94.5751 169.793 91.2062C168.816 91.1112 167.854 90.9703 166.9 90.8063C159.853 105.917 148.721 118.762 131.901 122.127Z",
    fill: "#1D1D1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M170.197 77.5504C168.832 75.4051 166.253 74.4294 163.851 73.5897C157.843 71.4894 151.835 69.3901 145.827 67.2898C144.358 66.776 143.211 66.601 142.269 66.662C144.851 82.0699 156.353 89.8953 169.791 91.2068C171.303 86.1825 172.145 80.6094 170.197 77.5504Z",
    fill: "#876855"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.5,
    d: "M170.197 77.5504C168.832 75.4051 166.253 74.4294 163.851 73.5897C157.843 71.4894 151.835 69.3901 145.827 67.2898C144.358 66.776 143.211 66.601 142.269 66.662C144.851 82.0699 156.353 89.8953 169.791 91.2068C171.303 86.1825 172.145 80.6094 170.197 77.5504Z",
    fill: "#1D1D1B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M144.945 77.1982C150.659 85.1136 159.079 89.979 169.606 91.9153",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M190.433 43.8758C190.3 47.6296 193.535 50.8645 194.279 54.5593C196.408 65.1387 189.637 76.307 181.081 82.0991C174.319 86.6756 165.828 87.1954 157.919 86.7086C153.359 86.4287 148.762 85.417 144.842 83.0708C138.942 79.5389 136.077 73.6359 132.188 68.2977C127.324 61.6199 123.338 53.6586 122.987 45.2803C122.785 40.4769 123.648 35.6575 125.525 31.231C130.629 19.199 142.453 11.1397 155.3 9.70018C159.495 9.23033 163.762 9.34329 167.928 10.0231C174.774 11.1397 180.986 15.0964 185.097 20.6545C190.012 27.3003 191.1 35.5286 190.45 43.5929C190.442 43.6879 190.437 43.7828 190.433 43.8758Z",
    fill: "#876855"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M124.481 60.8422C122.37 62.1358 121.932 65.1738 122.841 67.477C123.751 69.7802 125.659 71.5167 127.506 73.1661C128.215 73.7989 128.945 74.4457 129.834 74.7796C131.061 75.2404 132.457 75.0445 133.662 74.5277C134.866 74.0108 135.916 73.1981 136.952 72.3944C137.165 72.2294 137.386 72.0525 137.485 71.8016C138.103 70.2391 135.623 64.7969 134.409 63.4673C132.35 61.2141 127.32 59.1028 124.481 60.8422Z",
    fill: "#876855"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    opacity: 0.3,
    d: "M187.197 51.7056C185.743 51.5407 184.208 51.9515 183.045 52.8572C180.49 54.8476 179.842 58.5633 181.953 61.0195C182.755 61.9522 183.785 62.7639 184.999 62.9619C185.583 63.0568 186.18 63.0048 186.765 62.9189C187.525 62.8069 188.283 62.635 188.981 62.3141C192.71 60.5977 192.696 54.4487 189.239 52.3834C188.614 52.0095 187.915 51.7866 187.197 51.7056Z",
    fill: "#1D1D1B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    opacity: 0.3,
    d: "M149.307 57.8258C147.7 57.6428 146.005 58.0977 144.722 59.0973C141.9 61.2956 141.183 65.3993 143.515 68.1124C144.4 69.142 145.539 70.0397 146.879 70.2576C147.524 70.3626 148.184 70.3056 148.83 70.2096C149.669 70.0857 150.506 69.8958 151.277 69.5409C155.395 67.6455 155.38 60.8538 151.561 58.5735C150.872 58.1617 150.1 57.9157 149.307 57.8258Z",
    fill: "#1D1D1B"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M126.615 62.7873C124.934 63.0752 123.846 65.0436 124.392 66.629C124.466 66.845 124.759 66.769 124.834 66.604C125.549 65.0456 125.41 63.586 127.638 63.676C127.006 64.9526 127.014 67.2618 128.054 68.1915C128.276 68.3904 128.62 68.2545 128.583 67.9356C128.499 67.2238 128.139 66.587 128.084 65.8503C128.029 65.1105 128.226 64.4628 128.365 63.761C129.529 63.9789 130.595 64.5807 131.531 65.2865C131.661 65.3844 131.871 65.2165 131.78 65.0715C130.806 63.5271 128.435 62.4754 126.615 62.7873Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M153.327 45.6865C153.642 45.5926 153.963 45.4916 154.223 45.2907C154.483 45.0907 154.675 44.7688 154.63 44.4439C154.582 44.0941 154.272 43.8242 153.933 43.7242C153.594 43.6242 153.231 43.6622 152.882 43.7182C151.209 43.9851 149.595 44.6359 148.215 45.6186C148.007 45.7665 147.799 45.9275 147.667 46.1454C146.805 47.5699 149.031 46.7472 149.455 46.6602C150.759 46.3923 152.052 46.0674 153.327 45.6865Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M184.252 41.3316C184.688 41.2836 185.247 41.1077 185.248 40.6688C185.248 40.241 184.71 40.056 184.285 40.0081C182.475 39.8031 180.638 39.8561 178.844 40.164C177.054 40.4709 176.356 42.2013 178.658 41.9474C180.521 41.7415 182.387 41.5365 184.252 41.3316Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M173.56 57.0016C173.005 54.9053 170.38 54.8713 168.729 55.4971C168.644 55.5291 168.688 55.639 168.766 55.64C170.267 55.661 172.874 55.2762 173.056 57.4724C173.2 59.2139 171.534 60.2785 170.227 61.0263C169.961 61.1782 170.225 61.6501 170.495 61.4981C172.084 60.6034 174.123 59.1299 173.56 57.0016Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M169.498 70.0487C167.057 70.3396 164.771 70.3686 162.51 69.227C160.429 68.1763 159.187 66.5889 157.77 64.8155C157.681 64.7035 157.526 64.8065 157.563 64.9334C158.951 69.7498 165.156 72.278 169.7 70.8275C170.143 70.6875 169.945 69.9957 169.498 70.0487Z",
    fill: "#4E4E4E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_384_850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 46,
    width: 11,
    height: 7
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000143613284350766622960000002304939042871420335_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M185.768 50.2888C184.885 50.8536 183.879 51.2935 182.813 51.5904C181.325 52.0132 179.718 52.1612 178.176 52.0452C177.13 51.9662 176.102 51.7683 175.166 51.4414C175.498 50.5467 175.87 49.627 176.35 48.8113C176.889 47.8706 177.584 47.0619 178.542 46.574C179.912 45.8773 181.619 46.0272 182.948 46.788C183.28 46.9729 183.596 47.2028 183.881 47.4468L183.893 47.4558C184.752 48.2085 185.385 49.2132 185.768 50.2888Z",
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_384_850)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M185.768 50.2888C184.885 50.8536 183.879 51.2935 182.813 51.5904C181.325 52.0132 179.718 52.1612 178.176 52.0452C177.13 51.9662 176.102 51.7683 175.166 51.4414C175.498 50.5467 175.87 49.627 176.35 48.8113C176.889 47.8706 177.584 47.0619 178.542 46.574C179.912 45.8773 181.619 46.0272 182.948 46.788C183.28 46.9729 183.596 47.2028 183.881 47.4468L183.893 47.4558C184.752 48.2085 185.385 49.2132 185.768 50.2888Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_384_850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 46,
    width: 11,
    height: 7
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000143613284350766622960000002304939042871420335__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M185.768 50.2888C184.885 50.8536 183.879 51.2935 182.813 51.5904C181.325 52.0132 179.718 52.1612 178.176 52.0452C177.13 51.9662 176.102 51.7683 175.166 51.4414C175.498 50.5467 175.87 49.627 176.35 48.8113C176.889 47.8706 177.584 47.0619 178.542 46.574C179.912 45.8773 181.619 46.0272 182.948 46.788C183.28 46.9729 183.596 47.2028 183.881 47.4468L183.893 47.4558C184.752 48.2085 185.385 49.2132 185.768 50.2888Z",
    fill: "white"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_384_850)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M177.775 46.7327C176.254 47.5784 175.374 49.4438 175.689 51.1552C176.004 52.8667 177.489 54.2972 179.212 54.5471C180.934 54.797 182.764 53.8474 183.552 52.2949C185.384 48.6851 181.314 44.7654 177.775 46.7327Z",
    fill: "#4E505B"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_384_850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 148,
    y: 49,
    width: 12,
    height: 7
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000018212481199249138360000004599563772496057266_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M159.242 53.4392C158.358 54.004 157.352 54.4439 156.287 54.7408C154.798 55.1636 153.192 55.3116 151.649 55.1956C150.603 55.1166 149.575 54.9187 148.639 54.5918C148.971 53.6971 149.343 52.7774 149.823 51.9617C150.363 51.021 151.057 50.2123 152.015 49.7244C153.386 49.0277 155.092 49.1776 156.422 49.9384C156.753 50.1233 157.069 50.3532 157.354 50.5971L157.366 50.6061C158.226 51.3589 158.858 52.3626 159.242 53.4392Z",
    fill: "white"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_384_850)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M159.242 53.4392C158.358 54.004 157.352 54.4439 156.287 54.7408C154.798 55.1636 153.192 55.3116 151.649 55.1956C150.603 55.1166 149.575 54.9187 148.639 54.5918C148.971 53.6971 149.343 52.7774 149.823 51.9617C150.363 51.021 151.057 50.2123 152.015 49.7244C153.386 49.0277 155.092 49.1776 156.422 49.9384C156.753 50.1233 157.069 50.3532 157.354 50.5971L157.366 50.6061C158.226 51.3589 158.858 52.3626 159.242 53.4392Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_384_850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 148,
    y: 49,
    width: 12,
    height: 7
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000018212481199249138360000004599563772496057266__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M159.242 53.4392C158.358 54.004 157.352 54.4439 156.287 54.7408C154.798 55.1636 153.192 55.3116 151.649 55.1956C150.603 55.1166 149.575 54.9187 148.639 54.5918C148.971 53.6971 149.343 52.7774 149.823 51.9617C150.363 51.021 151.057 50.2123 152.015 49.7244C153.386 49.0277 155.092 49.1776 156.422 49.9384C156.753 50.1233 157.069 50.3532 157.354 50.5971L157.366 50.6061C158.226 51.3589 158.858 52.3626 159.242 53.4392Z",
    fill: "white"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_384_850)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M151.219 49.5159C149.698 50.3616 148.818 52.227 149.133 53.9384C149.448 55.6499 150.934 57.0804 152.656 57.3303C154.378 57.5802 156.209 56.6305 156.997 55.0781C158.829 51.4683 154.759 47.5486 151.219 49.5159Z",
    fill: "#4E505B"
  })))))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    opacity: 0.8,
    d: "M150.784 21.1073C156.924 27.4702 166.43 30.3802 175.079 28.5448C177.319 28.07 179.6 27.2313 181.106 25.5058C182.611 23.7804 183.066 20.9773 181.608 19.2109",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    opacity: 0.8,
    d: "M143.572 21.9209C133.765 27.598 128.785 40.6027 128.923 50.0006",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    opacity: 0.8,
    d: "M154.212 19.0123C157.578 21.4635 161.511 23.3678 165.672 23.4838C169.835 23.5988 174.217 21.6254 176.139 17.9316",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    opacity: 0.8,
    d: "M155.529 14.7083C159.842 15.809 164.684 14.5414 167.904 11.4694C169.028 10.3978 169.976 9.0932 170.383 7.5957C170.788 6.0972 170.594 4.39076 169.64 3.16617C168.687 1.94358 167.126 1.34678 165.594 1.11185C163.485 0.787961 161.129 1.12985 159.615 2.63435C158.102 4.13885 157.907 6.9929 159.607 8.28247",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    opacity: 0.8,
    d: "M141.341 17.8721C133.689 19.6015 127.289 25.9854 125.541 33.6338",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    opacity: 0.8,
    d: "M167.236 31.3474C171.122 32.507 175.345 32.516 179.238 31.3734C182.324 30.4677 185.341 28.6992 186.821 25.8442C188.301 22.9891 187.709 18.9455 184.952 17.29",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    opacity: 0.8,
    d: "M168.599 25.7097C173.604 25.7417 178.44 22.2868 180.033 17.5424C181.626 12.798 179.853 7.12486 175.843 4.13086",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    opacity: 0.8,
    d: "M135.29 24.7334C127.922 31.3012 124.089 41.6218 125.383 51.4075",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M30.6606 104.271C29.6949 105.165 36.0698 113.211 36.8106 114.073C39.4327 117.124 42.4517 119.821 45.6227 122.287C48.5227 124.542 51.6496 127.117 55.1135 128.396C58.7153 129.726 62.2341 128.948 65.9449 128.566C70.2455 128.123 74.517 127.285 78.5826 125.792C85.9472 123.089 92.697 118.036 96.1248 110.98C98.4121 106.273 98.9179 100.111 95.439 96.2019C92.7549 93.1869 88.4034 92.2712 84.3658 92.2892C75.5327 92.3271 66.7806 96.1659 60.7706 102.64C55.2624 98.929 46.5003 96.4758 40.3154 94.0556C33.5826 91.4204 23.522 91.2675 17.6699 95.5131C15.4487 97.1256 13.5163 99.3038 12.7925 101.951C12.0688 104.599 12.7816 107.741 14.9758 109.391C17.0801 110.974 20.0761 110.897 22.5033 109.874C24.9305 108.851 28.7282 106.06 30.6606 104.271Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M32.5631 110.936C31.0896 110.315 29.2982 109.162 27.7277 108.898C26.0333 108.614 25.8903 109.471 24.5997 110.687C22.4204 112.741 19.7783 114.306 16.9223 115.21C14.893 115.852 12.5008 116.11 10.7873 114.847C9.61971 113.987 8.9839 112.544 8.83595 111.101C8.688 109.66 8.97793 108.208 9.3658 106.812C11.84 97.9166 18.6207 88.3608 28.7813 89.2155C31.8193 89.4714 34.6584 90.3731 37.4264 91.3178C36.8816 97.4048 34.4924 104.957 32.5631 110.936Z",
    fill: "#FF766F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M37.2834 91.4033C36.0898 98.0251 34.3654 104.551 32.1311 110.897",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M74.874 92.1482C78.7747 91.2495 82.8413 90.7397 86.78 91.4555C90.7187 92.1722 94.5394 94.2455 96.6887 97.6234C99.9576 102.76 98.6551 109.774 95.2172 114.799",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    opacity: 0.5,
    d: "M55.1526 125.054C58.3425 123.464 62.6041 124.482 64.7314 127.341",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M189.154 123.575C188.993 123.599 188.833 123.628 188.672 123.666C188.888 123.615 189.261 123.741 189.479 123.778C189.759 123.825 190.038 123.882 190.313 123.947C190.814 124.065 191.309 124.09 191.72 124.443C192.072 124.745 192.261 125.288 192.023 125.686C191.789 126.076 191.274 126.172 190.822 126.215C189.995 126.297 189.163 126.34 188.33 126.345C189.187 126.612 192.2 127.524 190.954 128.805C190.2 129.58 187.673 129.43 186.678 129.438C187.059 129.435 187.524 129.839 187.812 130.049C188.192 130.326 188.617 130.621 188.737 131.105C188.821 131.444 188.744 131.834 188.489 132.072C188.305 132.243 188.048 132.322 187.796 132.336C187.005 132.38 186.26 132.076 185.501 131.897C183.64 131.458 181.782 131.003 179.93 130.533C177.505 129.917 176.246 129.259 173.764 130.162C165.525 133.157 156.19 133.676 147.794 131.002C139.788 128.453 132.81 124.802 128.053 117.552C125.232 113.252 120.97 104.776 124.926 100.125C126.777 97.9499 129.646 96.8982 132.467 96.4574C137.513 95.6687 140.715 99.4964 144.26 102.356C148.4 105.696 152.153 109.516 155.416 113.718C155.912 114.348 158.661 114.198 159.404 114.295C160.999 114.502 162.583 114.803 164.143 115.196C167.264 115.981 170.292 117.133 173.144 118.626C174.827 119.507 175.666 118.845 177.435 118.547C179.082 118.27 180.766 118.21 182.43 118.359C184.703 118.562 186.944 119.154 189.015 120.116C189.754 120.458 191.505 121.077 191.839 121.896C192.335 123.113 190.925 123.411 189.99 123.489C189.709 123.509 189.431 123.534 189.154 123.575Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M122.776 96.6315C118.178 108.633 125.399 118.351 125.399 118.351C125.399 118.351 136.07 120.112 149.659 105.177C149.659 105.177 135.091 81.4865 122.776 96.6315Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    opacity: 0.5,
    d: "M122.776 96.6315C118.178 108.633 125.399 118.351 125.399 118.351C125.399 118.351 136.07 120.112 149.659 105.177C149.659 105.177 135.091 81.4865 122.776 96.6315Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M149.816 103.812C144.323 111.097 134.192 117.639 124.569 117.669",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    opacity: 0.5,
    d: "M155.309 114.519C153.759 114.31 152.139 114.655 150.811 115.481",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    opacity: 0.5,
    d: "M142.789 126.758C145.551 125.906 148.807 127.07 150.403 129.479",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby10Weeks);
export default __webpack_public_path__ + "static/media/baby-10-weeks.ba1fdec414277f30f060a6e1595cdbed.svg";
export { ForwardRef as ReactComponent };